// english

export default {
  configModel_title: 'Data Model Management',
  configModel_group_title: 'Category Management',
  configModel_group_list: 'Category List',
  configModel_item_edit_title: 'Edit Data Item',
  configModel_item_add_title: 'Add Data Item',
  configModel_item_fork_title: 'Fork Data Item',

  // btn
  configModel_btn_add_item: 'Add Data Item',
  configModel_btn_add_group: 'Add Category',
  configModel_btn_edit_group: 'Edit Category',

  // table
  configModel_table_range: 'Value Range',
  configModel_table_unit: 'Unit',
  configModel_table_group_name: 'Category Name',

  // confirm
  configmModel_confirm_delete_title: 'Are you sure you want to delete this item?',
  configmModel_confirm_delete_some_title: 'Are you sure you want to delete these items?',
  configmModel_confirm_delete_content: 'Selected IDs: {ids}',
  configmModel_confirm_delete_group: 'Are you sure you want to delete this category?',
  configmModel_confirm_delete_group_content: 'Category Name: {name}',
  configmModel_confirm_delete_group_title: 'Are you sure you want to delete this category?',
  configmModel_confirm_delete_some_group_title: 'Are you sure you want to delete these categories?',
  configmModel_confirm_delete_group_content_ids: 'Category IDs: {ids}',

  // form
  configModel_form_item_name: 'Data Item Name',
  configModel_form_item_name_placeholder: 'Please enter data item name',
  configModel_form_group_name: 'Category Name',
  configModel_form_group_name_placeholder: 'Please select a category',
  configModel_form_group_name_placeholder2: 'Please enter category name',
  configModel_form_item_type: 'Data Item Type',
  configModel_form_item_type_placeholder: 'Please select a type',
  configModel_form_item_data_range: 'Data Range',
  configModel_form_item_data_range_placeholder: 'Please enter data range',
  configModel_form_item_unit: 'Data Item Unit',
  configModel_form_item_unit_placeholder: 'Please enter unit',
};
